import useUiContext from "@/custolink-hooks/useUiContext";
import { useMutation } from "@tanstack/react-query";
import { AssetFrontendUserApi } from "@/custolink-transpiled_by_server/bc.identity_and_access.api_methods";
import { useTranslation } from "react-i18next";
import { LanguageSelect } from "@/custolink-views/asset_frontend/ui/LanguageSelect";
import { RdaLanguageSelect } from "@/custolink-views/asset_frontend/redesigns/RdaLanguageSelect";
import { useAssetFrontendDesign } from "@/custolink-views/asset_frontend/redesigns/assetFrontendDesign";
import { PrimaryButton } from "@/custolink-views/asset_frontend/redesigns/formKit";

const LABEL = "text-[11px] font-bold uppercase tracking-[0.12em] text-[var(--rda-muted)]";

// Shared with the classic design (same AccountDrawer content as PresentOptionsPart), so the
// language picker follows the asset-frontend switch; the rest of this file was already
// redesigned unconditionally by an earlier batch.
export default function UserAuthedInfoPart() {
  const uic = useUiContext();
  const m = useMutation({
    mutationFn: () => AssetFrontendUserApi.signout(),
  })
  const { t } = useTranslation();
  const newDesign = useAssetFrontendDesign();
  return (
    <div className="space-y-5">
      <div>
        <h6 className={LABEL}>{t("account.info.usernameTitle")}</h6>
        <p className="mt-1 text-sm">{uic.assetFrontendAuthedUser?.email}</p>
        {uic.assetFrontendAuthedUser?.emailUnverified != null && (
          <p className="mt-1 text-xs text-[var(--rda-muted)]">
            {uic.assetFrontendAuthedUser?.emailUnverified}
            &nbsp;({t("account.unverified.mustVerifyEmail")})
          </p>
        )}
      </div>

      <div>
        <h6 className={LABEL}>{t('account.info.nameTitle')}</h6>
        <p className="mt-1 text-sm">{uic.assetFrontendAuthedUser?.name}</p>
      </div>

      {uic.organisationContext.assetFrontendi18nEnabled && (
        <div>
          <h6 className={LABEL}>{t("account.info.language")}</h6>
          <div className="mt-2">
            {newDesign ? <RdaLanguageSelect /> : <LanguageSelect />}
          </div>
        </div>
      )}

      <PrimaryButton
        type="button"
        onClick={async () => {
          await m.mutateAsync();
          document.location.reload();
        }}
      >
        {t('account.signOut')}
      </PrimaryButton>
    </div>
  );
}
